import {
  User,
  Phone,
  Mail,
  CalendarDays,
  Building2,
  ClipboardList,
  MapPin,
  Star,
} from "lucide-react";

const CustomerDetails = ({ customer, setCustomer }) => {
  const handleChange = (e) => {
  const { name, value } = e.target;

  let updatedValue = value;

  // Phone Number
  if (name === "phone") {
    updatedValue = value.replace(/\D/g, "").slice(0, 10);
  }

  setCustomer((prev) => ({
    ...prev,
    [name]: updatedValue,
  }));
};

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">

      {/* Heading */}
      <div className="mb-6">
        <h2 className="text-xl font-bold text-gray-800">
          Customer Details
        </h2>

        <p className="text-sm text-gray-500 mt-1">
          Fill customer information carefully
        </p>
      </div>

      {/* Form */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">

        {/* Customer Name */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Customer Name
          </label>

          <div className="relative">
            <User
              size={18}
              className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
            />

           <input
  type="text"
  required
  name="customer_name"
  value={customer.customer_name || ""}
  onChange={handleChange}
  autoComplete="name"
  placeholder="Enter customer name"
  className="w-full h-11 rounded-lg border border-gray-300 pl-10 pr-4 outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
/>
          </div>
        </div>

        {/* Phone */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Phone Number
          </label>

          <div className="relative">
            <Phone
              size={18}
              className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
            />

            <input
  type="tel"
  required
  name="phone"
  value={customer.phone || ""}
  onChange={handleChange}
  inputMode="numeric"
  maxLength={10}
  autoComplete="tel"
  placeholder="Enter phone number"
  className="w-full h-11 rounded-lg border border-gray-300 pl-10 pr-4 outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
/>
          </div>
        </div>

        {/* Email */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Email Address
          </label>

          <div className="relative">
            <Mail
              size={18}
              className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
            />

           <input
  type="email"
  name="email"
  value={customer.email || ""}
  onChange={handleChange}
  autoComplete="email"
  spellCheck={false}
  autoCapitalize="none"
  placeholder="Enter email address"
  className="w-full h-11 rounded-lg border border-gray-300 pl-10 pr-4 outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
/>
          </div>
        </div>

        {/* DOB */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Date Of Birth
          </label>

          <div className="relative">
            <CalendarDays
  size={18}
  className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
/>

            <input
  type="date"
  name="date_of_birth"
  value={customer.date_of_birth || ""}
  onChange={handleChange}
  max={new Date().toISOString().split("T")[0]}
  className="w-full h-11 rounded-lg border border-gray-300 pl-10 pr-4 outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
/>
          </div>
        </div>

        {/* Age (alternative to DOB) */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Age <span className="text-xs font-normal text-gray-400">(fill Age or Date of Birth)</span>
          </label>
          <input
            name="age"
            value={customer.age || ""}
            onChange={handleChange}
            inputMode="numeric"
            placeholder="e.g. 32"
            data-testid="customer-age"
            className="w-full h-11 rounded-lg border border-gray-300 px-4 outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
          />
        </div>

        {/* Favourite */}
        <div className="flex items-end">
          <label className="inline-flex cursor-pointer items-center gap-2 rounded-lg border border-gray-200 bg-slate-50 px-4 h-11 text-sm font-medium text-gray-700">
            <input
              type="checkbox"
              checked={!!customer.favourite}
              onChange={(e) => setCustomer((prev) => ({ ...prev, favourite: e.target.checked }))}
              data-testid="customer-favourite"
              className="h-4 w-4 accent-amber-500"
            />
            <Star size={16} className={customer.favourite ? "fill-amber-400 text-amber-400" : "text-slate-400"} />
            Mark as favourite
          </label>
        </div>

        {/* Visit Branch */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Visit Branch
          </label>

          <div className="relative">
            <Building2
              size={18}
              className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
            />

            <input
              list="branch-list"
              name="branch"
              value={customer.branch || ""}
              onChange={handleChange}
              autoComplete="off"
              placeholder="Select or type branch"
              className="w-full h-11 rounded-lg border border-gray-300 pl-10 pr-4 outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
            />
            <datalist id="branch-list">
              <option value="Z.A. Optical Johripur" />
              <option value="Z.A. Optical Jhilmil" />
            </datalist>
          </div>
        </div>

        {/* Visit For */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Visit For
          </label>

          <div className="relative">
            <ClipboardList
              size={18}
              className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
            />

            <input
              list="visitfor-list"
              name="visit_for"
              value={customer.visit_for || ""}
              onChange={handleChange}
              autoComplete="off"
              placeholder="Select or type purpose"
              className="w-full h-11 rounded-lg border border-gray-300 pl-10 pr-4 outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
            />
            <datalist id="visitfor-list">
              <option value="Only Visit" />
              <option value="Eye Test" />
              <option value="Lens Only" />
              <option value="Frame Only" />
              <option value="Complete Specs" />
              <option value="Specs Repair" />
            </datalist>
          </div>
        </div>

      </div>

      {/* Address */}
      <div className="mt-5">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Address
        </label>

        <div className="relative">
          <MapPin
            size={18}
            className="absolute left-3 top-4 text-gray-400"
          />

         <textarea
  rows={4}
  name="address"
  value={customer.address || ""}
  onChange={handleChange}
  autoComplete="street-address"
  maxLength={300}
  placeholder="Enter customer address"
  className="w-full resize-none rounded-lg border border-gray-300 py-3 pl-10 pr-4 outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
/>
        </div>
      </div>

    </div>
  );
};

export default CustomerDetails;